var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlachHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.997,
    height: 27,
    viewBox: "0 0 26.997 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home2",
    d: "M26.272,11.744l0,0L15.256.728a2.485,2.485,0,0,0-3.515,0L.732,11.736l-.011.011a2.485,2.485,0,0,0,1.654,4.235q.038,0,.077,0h.439v8.105A2.912,2.912,0,0,0,5.8,27h4.309a.791.791,0,0,0,.791-.791V19.855a1.329,1.329,0,0,1,1.327-1.327h2.542A1.329,1.329,0,0,1,16.1,19.855v6.355a.791.791,0,0,0,.791.791H21.2a2.912,2.912,0,0,0,2.909-2.909V15.986h.407a2.486,2.486,0,0,0,1.759-4.242Zm0,0",
    transform: "translate(0.001)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlachHomeIcon);
export default __webpack_public_path__ + "static/media/blachHomeIcon.dcada8f6b7026a9c7c52be2b318975ee.svg";
export { ForwardRef as ReactComponent };